import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 37"
};
function n(c, r) {
  return l(), t("svg", o, [...r[0] || (r[0] = [
    e("path", {
      fill: "currentColor",
      d: "M0 7h7v19H0z"
    }, null, -1),
    e("path", {
      stroke: "currentColor",
      d: "M3.5 0v37"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "M12 15.5h7v7h-7z"
    }, null, -1),
    e("path", {
      stroke: "currentColor",
      d: "M15.5 5.5v26"
    }, null, -1)
  ])]);
}
const u = { render: n };
export {
  u as default,
  n as render
};
